//
//
//
//
//

import { getToken, setToken, removeToken } from '@/store/getToken'
import promise from '@/axios/promise'
export default {
    name:'',
    data(){
        return {
            // 日报日期
            calDate: this.$route.query.calDate,
            username: this.$route.query.username,
            wechatCode: this.$route.query.wechatCode,
        }
    },
    methods:{
        // 跳转至日报填写界面
        forwardToTaskList(){
            this.$router.push({ path: '/app/workRep/dayReport',query:{calDate:this.calDate}});
        },
        //获取token
        getTokenByWechatCode(){
            promise({
                url:"/token/generateToken",
                method:'post',
                params:{username:this.username,password:"",wechatCode:this.wechatCode}
            }).then(res=>{
                if(res.status=='S'){
                    setToken(res.token);
                    sessionStorage.setItem('username', this.username);
                    this.forwardToTaskList();
                }else{
                    this.$router.push({path:'/login'});
                }
            });
        },
    },
    mounted(){
        this.getTokenByWechatCode();
    }
}



// WEBPACK FOOTER //
// ./src/view/wechat/dailyDeal.vue